module.exports = __webpack_public_path__ + "static/media/comingsoon.729288de.jpg";